import { AppointmentCancellationReason } from '@lendi/core-constants';

export const CANCELLATION_REASON = [
  {
    label: 'Customer not responding',
    value: AppointmentCancellationReason.CustomerNotResponding,
  },
  {
    label: 'Exploring options',
    value: AppointmentCancellationReason.ExploringOptions,
  },
  {
    label: 'Happy with current bank & rates',
    value: AppointmentCancellationReason.HappyWithCurrentBankAndRates,
  },
  {
    label: 'Servicing income or employment',
    value: AppointmentCancellationReason.ServicingIncomeOrEmployment,
  },
  {
    label: 'Duplicated appointment',
    value: AppointmentCancellationReason.DuplicatedAppointment,
  },
  {
    label: 'Credit issues',
    value: AppointmentCancellationReason.CreditIssues,
  },
  {
    label: 'Refinance LVR under 80%',
    value: AppointmentCancellationReason.LowRefinanceLvr,
  },
  {
    label: 'Insufficient deposit',
    value: AppointmentCancellationReason.InsufficientDeposit,
  },
  {
    label: 'Insufficient exit strategy',
    value: AppointmentCancellationReason.InsufficientExitStrategy,
  },
  {
    label: 'Purchasing > 3 months',
    value: AppointmentCancellationReason.PurchasingAfterThreeMonths,
  },
  {
    label: 'Pending legal matter',
    value: AppointmentCancellationReason.PendingLegalMatter,
  },
];
